/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { HTMLAttributes } from 'react'
import { Box } from '@mantine/core'

export type FilterableProps<T = string> = {
  onChange (name: string, value?: T): void,
  value?: T
}

export type FilterProps = HTMLAttributes<HTMLDivElement> & {
  label?: string
}

function Filter (props: FilterProps) {
  const { children, label } = props
  return (
    <Box>
      {label ? (<div>{label}</div>) : null}
      {children}
    </Box>
  )
}

export default Filter
